import { Button, Typography } from "@kyan/ui";
import Image from "next/image";
import Link from "next/link";

import { routes } from "#/config/routes";

export const EmptyState: React.FC = () => {
  return (
    <div className="bg-buttonHover grid min-h-48 place-items-center content-center gap-2 overflow-y-hidden">
      <Image
        alt="Kyan"
        width={60}
        height={60}
        src="/images/common/kyan-crystal.png"
      />
      <Typography
        element="p"
        variant="secondary"
        className="flex items-center gap-1"
      >
        Choose a strategy and start adding legs here, or head to the
        <Link href={routes.options({ panelTab: "combo" })}>
          <Button variant="link">Options orderbook</Button>
        </Link>
      </Typography>
    </div>
  );
};
